import * as React from "react";

import {
  DefaultValuesDetailsForm,
  DetailsFormValues,
} from "../WebCheckInForms/WebCheckInForms.props";
import { AppInputSwitchProps } from "../AppInputSwitcher/AppInputSwitcher.props";
import { AppInputSwitcher } from "../AppInputSwitcher/AppInputSwitcher";
import { DriverFormFields } from "../WebCheckInForms/FormKeys";
import { FormFieldErrorMessage } from "../../UI/FormFieldErrorMessage/FormFieldErrorMessage";
import { ReadOnlyIfInitialValuesNotProvided } from "../WebCheckInForms/FormOptions";
import { Controller, RegisterOptions } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useWebCheckInForm } from "../../../hooks/WebCheckInForm_2";
import { useEffect, useRef, useState } from "react";
import { BookingApi } from "../../../API/Apis/BookingApi";
import { useNavigate } from "react-router-dom";
import AppButton from "../../UI/AppButtons";
import { t } from "i18next";
import BookingGetters from "../../../store/onlineBooking/getters";
import { ChosenOptions } from "../BookingVehicleInfoCard/BookingVehicleInfoCard.props";
import CollapsibleNavbar from "../ReservedAreaDashboard/CollapseNavbar";
import {
  getParentOrigin,
  allowedOrigins,
} from "../../../helpers/iframeSource.ts";
import Recep from "../../../views/chooseVehicle/Recep.tsx";

export function DriverAddForm({
  heading,
  dealerId,
  openDriverAfterCompanyDriver = false,
}) {
  const initialValues = DefaultValuesDetailsForm;
  const [openDriverAfterCompany, setOpenDriverAfterCompanyDriver] = useState(
    openDriverAfterCompanyDriver
  );
  const [driverDetails, setCurrentDriverDetails] = useState<DetailsFormValues>({
    ...DefaultValuesDetailsForm,
  });
  const clearFormFields = () => {
    setCurrentDriverDetails({
      ...DefaultValuesDetailsForm,
    });
    Object.keys(driverFormFields).forEach((field) => {
      setValue(field, "");
    });
    setValue("telephone", "+39");
    setValue("streetNumber", "");
    setValue("birthProvince", "");
    setValue("document", "");
    setValue("sex", "");
    setValue("dateOfBirth", null, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    setValue("documentExpiryDate", null, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    setValue("releaseDate", null, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };
  const searchParams = new URLSearchParams(location.search);
  const [isCompanyUserType, setIsCompanyUserType] = useState(
    searchParams.get("isCompanyUserType") == "true"
  );
  const [isDriverFromAnagraph, setIsDriverFromAnagraph] = useState(
    searchParams.get("isDriverFromAnagraph") == "true"
  );
  const [shouldReload, setShouldReload] = useState(false);
  useEffect(() => {
    if (shouldReload) {
      setShouldReload(false);
      clearFormFields();
    }
  }, [location.search]);
  const [
    {
      register,
      formState: { errors },
      getValues,
      setValue,
      control,
      handleSubmit: rhfHandleSubmit,
    },
    driverFormFields,
  ] = useWebCheckInForm(
    DriverFormFields,
    {
      ...Object.keys(initialValues).reduce((prevValue, currentKey) => {
        prevValue[currentKey] = initialValues[currentKey]
          ? initialValues[currentKey]
          : driverDetails[currentKey] || DefaultValuesDetailsForm[currentKey];

        return prevValue;
      }, {}),
    } as DetailsFormValues,
    (e) => {
      setCurrentDriverDetails({ ...driverDetails, ...e });
    }
  );
  const navigateTo = useNavigate();
  const { t: translate } = useTranslation();
  const isSmallScreen = window.innerWidth <= 768;
  const handleCountryChange = (newCountryValue) => {
    setValue("country", newCountryValue || "");
    setValue("city", "");
    setValue("state", "");
  };
  const [documentTypes] = useState([t("Driver License")]);
  const selectedVehicle = BookingGetters.getSelectedVehicleDetails();
  const [, setSelectedFields] = useState<ChosenOptions>({
    options: {},
    insurance: undefined,
  });
  const [, setIsPaymentPage] = useState(false);
  useEffect(() => {
    setIsPaymentPage(true);
  }, []);
  const bookingInformation = BookingGetters.getBookingDetails();
  const supplierId =
    bookingInformation?.pickUpLocationDetails?.dealerId || dealerId;
  const [offsetFromTop, setOffsetFromTop] = useState(0);
  const divRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const calculateOffset = () => {
      if (divRef.current) {
        const rect = divRef.current.getBoundingClientRect();
        setOffsetFromTop(rect.top);
      }
    };
    calculateOffset();
    const handleScroll = () => {
      calculateOffset();
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    scrollToTop();
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setSelectedFields({
      options: selectedVehicle?.paymentDetails.addedExtraOptions || {},
      insurance: selectedVehicle?.paymentDetails.selectedInsurance,
    });
  }, [selectedVehicle]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const paymentDetailsSelected =
    BookingGetters.getSelectedVehicleDetails()?.paymentDetails;
  const extrasSelected = paymentDetailsSelected?.addedExtraOptions;
  const [isDriverOptionalSelected, setIsDriverSelected] = useState(false);
  const isPhysicalPerson: any = localStorage.getItem("isPhysicalPerson");
  const [additionalDriverCount, setAdditionalDriverCount] = useState(0);
  useEffect(() => {
    if (Array.isArray(extrasSelected)) {
      const driverExtras = extrasSelected.filter((el) => el.name === "DRIVER");
      if (driverExtras != null && driverExtras.length > 0) {
        setAdditionalDriverCount(driverExtras[0].quantity);
      }
    } else if (
      typeof extrasSelected === "object" &&
      extrasSelected !== null &&
      "DRIVER" in extrasSelected
    ) {
      setAdditionalDriverCount(extrasSelected.DRIVER.quantity);
      setIsDriverSelected(true);
    } else {
      setIsDriverSelected(false);
    }
  }, [extrasSelected]);
  if (
    openDriverAfterCompany &&
    additionalDriverCount == 3 &&
    isPhysicalPerson == "false"
  ) {
    setAdditionalDriverCount(2);
  }
  const navigateDriverForms = (count, lastDriverId) => {
    if (count > 0) {
      const driverIndex = additionalDriverCount - count + 2; // Ensures unique key names
      if (!localStorage.getItem(`additionalDriver${driverIndex}`)) {
        localStorage.setItem(`additionalDriver${driverIndex}`, lastDriverId);
      }
      setTimeout(() => {
        navigateTo(
          `/driverForm?updatedCount=${count}&isCountUpdated=true&showRecep=true`
        );
      }, 500);
    } else {
      navigateTo("/paymentData");
    }
  };
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };
  const parentOrigin = getParentOrigin();
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: 520 + driverPageDivHeight + 120, //520 is recep height and 120 is for scroll
        },
      },
      targetOrigin
    );
  }
  const onSubmit = async (data) => {
    try {
      const response = await BookingApi.createOnlineuserCustomer(
        data,
        "driver",
        supplierId || "",
        "soletrader"
      );

      if (response.status === "success") {
        handleSuccessfulResponse(response.id);
      } else {
        handleErrorResponse(response.errorMessage);
      }
    } catch (error) {
      console.warn("Something went wrong while saving details....", error);
    }
  };

  const handleSuccessfulResponse = (id) => {
    if (isCompanyUserType && isDriverFromAnagraph) {
      localStorage.setItem("attachedDriver", id);
      if (isDriverOptionalSelected) {
        resetFormAndNavigate(
          `/driverForm?isCallFromBooking=true&isDriver=true&showRecep=true`
        );
      } else {
        navigateTo("/paymentData");
      }
    } else if (
      !isCompanyUserType &&
      !isDriverFromAnagraph &&
      isDriverOptionalSelected
    ) {
      handleAdditionalDriver(id);
    } else {
      localStorage.setItem("attachedDriver", id);
      navigateTo("/paymentData");
    }
  };

  const handleAdditionalDriver = (id) => {
    if (openDriverAfterCompany) {
      localStorage.setItem("attachedDriver", id);
      resetFormAndNavigate(
        `/driverForm?isCallFromBooking=true&isDriver=true&showRecep=true`
      );
      setOpenDriverAfterCompanyDriver(false);
      return;
    }
    if (additionalDriverCount === 1) {
      localStorage.setItem("additionalDriver2", id);
    } else if (additionalDriverCount === 3) {
      setAdditionalDriverCount(2);
      if (isPhysicalPerson === "true") {
        localStorage.setItem("attachedDriver", id);
      }
      navigateTo(`/driverForm?showRecep=true`);
      return;
    } else {
      const isCountUpdated =
        searchParams.has("updatedCount") &&
        searchParams.get("isCountUpdated") === "true";
      const updatedCount = isCountUpdated
        ? Number(searchParams.get("updatedCount")) - 1
        : additionalDriverCount;
      if (updatedCount > 1) {
        clearFormFields();
        navigateDriverForms(updatedCount, id);
        return;
      }
      localStorage.setItem(`additionalDriver${additionalDriverCount + 1}`, id);
    }
    navigateTo("/paymentData");
  };
  const handleErrorResponse = (errorMessage) => {
    if (
      errorMessage === "More than one Account is registered with this email" ||
      errorMessage === "Account Not Registered with this Email ID"
    ) {
      alert(`${errorMessage}. Please contact the administrator.`);
      navigateTo("/");
    } else {
      console.warn("Error: ", errorMessage);
    }
  };

  const resetFormAndNavigate = (path) => {
    setIsCompanyUserType(false);
    setIsDriverFromAnagraph(false);
    navigateTo(path);
    scrollToTop();
    window.scrollTo(0, 0);
    setShouldReload(true);
    clearFormFields();
  };

  const selectedFields = BookingGetters.getselectedFields();
  const reduxPrices = BookingGetters.getReduxPrices();
  const selectedVehicleDetails = BookingGetters.getSelectedVehicleDetails();

  const { vehiclePrice, insurancePrice, onlyExtrasPrice, totalPrice } =
    reduxPrices.setPrices || {};
  const isShowRecep = searchParams.get("showRecep") === "true";
  const isRecepReady =
    selectedVehicleDetails?.vehicleDetails?.Vehicle &&
    selectedFields?.selectedFields?.selectedFields &&
    vehiclePrice != null &&
    insurancePrice != null &&
    onlyExtrasPrice != null &&
    totalPrice != null &&
    isShowRecep;
  const [driverPageDivHeight, SetDriverPageDivHeight] = useState<number>(0);
  const driverDataRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (driverDataRef.current) {
      const driverDataRefHeight = driverDataRef.current.offsetHeight;
      SetDriverPageDivHeight(driverDataRefHeight);
    }
  });
  useEffect(() => {
    requestParentResize();
  }, [driverPageDivHeight]);
  return (
    <div>
      <div>
        {isRecepReady && (
          <Recep
            offsetFromTop={offsetFromTop}
            divRef={divRef}
            activeStep="3"
            selectedVehicle={selectedVehicleDetails.vehicleDetails}
            selectedFields={selectedFields.selectedFields.selectedFields}
            vehiclePrice={vehiclePrice}
            insurancePrice={insurancePrice}
            onlyExtrasPrice={onlyExtrasPrice}
            totalPrice={totalPrice}
            isPaymentPage={false}
            fromAnagraphDriver={true}
          />
        )}
      </div>
      <div style={{ width: "2%" }}>
        <CollapsibleNavbar
          isDrawerOpen={isDrawerOpen}
          toggleDrawer={toggleDrawer}
        />
      </div>
      <div
        style={{
          width: !isSmallScreen ? "1259px" : "",
          margin: "auto",
          boxShadow: "0 2px 2px #B3B3B3, 0 2px 2px #B3B3B3",
        }}
        ref={driverDataRef}
      >
        {/*{isSmallScreen && (*/}
        {/*  <div*/}
        {/*    style={{*/}
        {/*      marginBottom: isSmallScreen ? "25px" : "",*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <Header callFrom="showcustomer" />*/}
        {/*  </div>*/}
        {/*)}*/}
        <div
          className={"flex flex-col md:flex-row items-center"}
          style={{
            margin: "20px",
          }}
        >
          <img
            src="/assets/images/SiteLogo.jpg"
            alt={"logo"}
            style={{
              height: "134px",
              width: "231.03px",
              marginTop: "47px",
              marginRight: !isSmallScreen ? "" : "82%",
            }}
          />
          <div>
            <h2
              className="text-black"
              style={{
                fontSize: !isSmallScreen ? "36px" : "31px",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              }}
            >
              {heading
                ? heading
                : searchParams.get("additionalDriver") == "true"
                ? "Insert additional driver data"
                : searchParams.get("additionalDriver2") == "true"
                ? "Insert additional driver-2 data"
                : translate("Insert driver data")}
            </h2>
            <h3
              className="text-black"
              style={{
                fontSize: !isSmallScreen ? "24px" : "20px",
                fontFamily: "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
              }}
            >
              {t("Insert anagraphic data of the driver.")}
            </h3>
          </div>
        </div>
        <div
          className="flex flex-col"
          style={{
            backgroundColor: "#000000",
          }}
        >
          <div
            style={{
              marginLeft: !isSmallScreen ? "148px" : "",
              marginTop: !isSmallScreen ? "60px" : "35px",
              marginBottom: !isSmallScreen ? "90px" : "",
            }}
          >
            <form onSubmit={rhfHandleSubmit(onSubmit)}>
              <div
                // className={"grid sm:grid-cols-2 md:grid-cols-2 gap-4"}
                className={` grid sm:grid-cols-2 md:grid-cols-2 gap-4 ${
                  isSmallScreen ? "box-border justify-center flex px-4" : ""
                }`}
              >
                {Object.values(driverFormFields).map(
                  (el: AppInputSwitchProps) => {
                    const readOnly =
                      el.readOnly ||
                      (ReadOnlyIfInitialValuesNotProvided.includes(el.key) &&
                        !!initialValues[el.key]);
                    const options: RegisterOptions = {
                      required: {
                        value:
                          !!el.required &&
                          initialValues[el.key] == null &&
                          !readOnly,
                        message: "This is a required field",
                      },
                    };

                    if (el.type === "email") {
                      options.pattern = {
                        value: /^[a-zA-Z\d+_.-]+@[a-zA-Z\d.-]+$/,
                        message: "Please provide a valid email",
                      };
                    }
                    if (el.key === driverDetails?.ssn?.key) {
                      options.maxLength = {
                        value: 16,
                        message: "Please provide a valid SSN",
                      };
                      options.minLength = {
                        value: 16,
                        message: "Please provide a valid SSN",
                      };
                    }
                    if (el.key == "document") {
                      el.type = "select";
                      el.variant = "with-search";
                      el.readOnly = false;
                      el.options = documentTypes;
                    }
                    const isControllerField = ["date"].includes(el.type);
                    return (
                      <div className="w-full h-full" key={el.key}>
                        {isControllerField ? (
                          <Controller
                            control={control}
                            name={el.key}
                            rules={{
                              required: "This field is required",
                            }}
                            render={({ field, fieldState }) => (
                              <AppInputSwitcher
                                {...el}
                                {...field}
                                value={field.value || null}
                                onchange={(e) => {
                                  field.onChange(e);
                                  setValue(el.key, e, {
                                    shouldValidate: true,
                                  });
                                }}
                                error={fieldState.error?.message}
                                containerwidth={
                                  !isSmallScreen ? "418px" : "330px"
                                }
                                containerheight="38px"
                                InputColor={true}
                                label={translate(el.label || "")}
                                placeholder={translate(el.placeholder || "")}
                                readOnly={readOnly}
                                minDate={el.minDate}
                                fontFamilyForLabel="MBCorpoSText-CondRegular-Web"
                                fontFamilyForInput="MBCorpoSText-CondRegular-Web"
                                showlabelOnShrink={false}
                                className={`box-border`}
                                showlabel={true}
                              />
                            )}
                          />
                        ) : (
                          <AppInputSwitcher
                            {...el}
                            {...register(el.key, {
                              ...options,
                            })}
                            showlabelOnShrink={false}
                            containerwidth={!isSmallScreen ? "418px" : "330px"}
                            containerheight="38px"
                            className={`box-border ${
                              el.key === "vatNumber" ? "invisible" : ""
                            } ${
                              (el.key === "sex" || el.key === "ssnNumber") &&
                              isSmallScreen
                                ? "mt-[0%]"
                                : ""
                            }`}
                            options={
                              el.key === "sex"
                                ? [translate("MALE"), translate("FEMALE")]
                                : el.options
                            }
                            InputColor={true}
                            label={translate(el.label || "")}
                            fontFamilyForLabel="MBCorpoSText-CondRegular-Web"
                            fontFamilyForInput="MBCorpoSText-CondRegular-Web"
                            showlabel={true}
                            readOnly={readOnly}
                            placeholder={translate(el.placeholder || "")}
                            value={getValues(el.key) || null}
                            onchange={(e) => {
                              if (el.key == "country") {
                                handleCountryChange(e);
                              }
                              setValue(el.key, e, {});
                            }}
                            onInvalid={(e) => {
                              const fieldKey = getValues(el.key);
                              if (e.target.validity.valueMissing && !fieldKey) {
                                e.target.setCustomValidity(
                                  translate("Please fill out this field")
                                );
                              } else {
                                e.target.setCustomValidity("");
                              }
                            }}
                          />
                        )}
                        <FormFieldErrorMessage>
                          {errors[el.key]?.message}
                        </FormFieldErrorMessage>
                      </div>
                    );
                  }
                )}
              </div>
              <div
                className={`flex flex-row gap-6 justify-end ${
                  isSmallScreen ? "box-border justify-center flex px-4" : ""
                }`}
                // className="flex flex-row gap-6 justify-end"
                style={{
                  marginRight: isSmallScreen ? "" : "12%",
                  marginBottom: "40px",
                  marginTop: "40px",
                }}
              >
                <AppButton
                  type="submit"
                  color="primary"
                  className="h-[38px] w-[410px] flex justify-center rounded-sm"
                >
                  <span
                    className="flex text-center w-full h-full mt-3 justify-center"
                    style={{
                      marginBottom: "14px",
                      fontFamily: "MBCorpoSText-Regular-Web-new",
                      textTransform: "none",
                    }}
                  >
                    {t("Confirm")}
                  </span>
                </AppButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
